import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, isRef as _isRef, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock, Teleport as _Teleport } from "vue"

const _hoisted_1 = ["data-dusk"]
const _hoisted_2 = { class: "flex items-center gap-4" }
const _hoisted_3 = { class: "w-28 h-28 p-2 rounded border flex items-center justify-center" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "flex-1" }
const _hoisted_6 = {
  class: "text-lg font-semibold",
  "data-dusk": "product-title"
}
const _hoisted_7 = { class: "border-t border-gray-200 mt-6" }
const _hoisted_8 = { class: "grid grid-cols-5 gap-6 mt-6" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { key: 3 }
const _hoisted_13 = { key: 4 }
const _hoisted_14 = { class: "grid grid-cols-5 gap-6 mt-6 items-end" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "flex-1" }
const _hoisted_17 = { class: "text-xs text-gray-500" }
const _hoisted_18 = { class: "mt-6 justify-between w-full" }
const _hoisted_19 = { class: "grid grid-cols-5 gap-6 items-end" }
const _hoisted_20 = { class: "col-span-4" }
const _hoisted_21 = { class: "col-span-1" }

import { computed, ref } from 'vue';
import { BaseButton } from '@/lib/components/Button';
import { BaseSelectDropdown } from '@/lib/components/Select';
import { NumberInput, BaseTextInput } from '@/lib/components/Input';
import { SearchInput } from '@/lib/components/Search';
import { useI18n } from 'vue-i18n';
import { useProductCard } from '@/composables/use-product-card';
import { LensProperty, ProductImage, Variant } from '@/models/webshop.model';
import AddPatientModal from '@/views/patient/AddPatientModal.vue';
import { useRoute } from 'vue-router';
import { Patient } from '@/models';

export default /*@__PURE__*/_defineComponent({
  __name: 'ProductCardLens',
  props: {
    mlsId: {},
    productCategory: {},
    productCategorySlug: {},
    title: {},
    image: {},
    lensProperties: {},
    variants: {},
    lensCode: {},
    dataDusk: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();
const route = useRoute();
const currentOrganisationId = computed(() => route.params.organisationId as string);

const {
  radius,
  diameter,
  power,
  cylinder,
  axis,
  pack,
  quantity,
  patient,
  patientSearchText,
  patientSuggestions,
  isPatientSearchLoading,
  radiusOptions,
  diameterOptions,
  powerOptions,
  cylinderOptions,
  axisOptions,
  packOptions,
  isAddToCartDisabled,
  handleAddToCart,
  validateReference,
  reference,
  handlePatientChange,
  isPatientSetting
} = useProductCard({
  mlsId: props.mlsId,
  productName: props.title,
  productCategory: props.productCategory,
  productCategorySlug: props.productCategorySlug,
  lensProperties: props.lensProperties,
  variants: props.variants,
  image: props.image,
  lensCode: props.lensCode,
  organisationId: currentOrganisationId
});

const cardDusk = computed(() => props.dataDusk || 'product-card-id');
const showModal = ref(false);
const handlePatientCreated = (newPatient: Patient) => {
  const patientSuggestion = {
    id: newPatient.id,
    value: newPatient.id,
    label: `${newPatient.first_name} ${newPatient.last_name} - ID: ${newPatient.mrn}` ||
           `${newPatient.first_name} ${newPatient.last_name}`
  };
  patient.value = newPatient;
  patientSearchText.value = patientSuggestion.label;
  patientSuggestions.value = [patientSuggestion];
  showModal.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "border rounded-lg p-10 shadow-sm bg-white w-full",
    "data-dusk": cardDusk.value
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _ctx.image?.url || 'https://placehold.co/350x180/EEEEEE/AAAAAA?text=No+image',
          alt: _ctx.title,
          class: "max-w-full max-h-full object-contain"
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.title), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        (_unref(radiusOptions) && _unref(radiusOptions).length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_unref(BaseSelectDropdown), {
                modelValue: _unref(radius),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(radius) ? (radius).value = $event : null)),
                label: _unref(t)('platform.webshop.radius'),
                placeholder: _unref(t)('platform.webshop.placeHolders.radius'),
                options: _unref(radiusOptions),
                "data-dusk": "radius-select"
              }, null, 8, ["modelValue", "label", "placeholder", "options"])
            ]))
          : _createCommentVNode("", true),
        (_unref(diameterOptions) && _unref(diameterOptions).length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_unref(BaseSelectDropdown), {
                modelValue: _unref(diameter),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(diameter) ? (diameter).value = $event : null)),
                label: _unref(t)('platform.webshop.diameter'),
                placeholder: _unref(t)('platform.webshop.placeHolders.diameter'),
                options: _unref(diameterOptions),
                "data-dusk": "diameter-select"
              }, null, 8, ["modelValue", "label", "placeholder", "options"])
            ]))
          : _createCommentVNode("", true),
        (_unref(powerOptions) && _unref(powerOptions).length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(_unref(BaseSelectDropdown), {
                modelValue: _unref(power),
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(power) ? (power).value = $event : null)),
                label: _unref(t)('platform.webshop.power'),
                placeholder: _unref(t)('platform.webshop.placeHolders.power'),
                options: _unref(powerOptions),
                "data-dusk": "power-select"
              }, null, 8, ["modelValue", "label", "placeholder", "options"])
            ]))
          : _createCommentVNode("", true),
        (_unref(cylinderOptions) && _unref(cylinderOptions).length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_unref(BaseSelectDropdown), {
                modelValue: _unref(cylinder),
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(cylinder) ? (cylinder).value = $event : null)),
                label: _unref(t)('platform.webshop.cylinder'),
                placeholder: _unref(t)('platform.webshop.placeHolders.cylinder'),
                options: _unref(cylinderOptions),
                "data-dusk": "cylinder-select"
              }, null, 8, ["modelValue", "label", "placeholder", "options"])
            ]))
          : _createCommentVNode("", true),
        (_unref(axisOptions) && _unref(axisOptions).length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createVNode(_unref(BaseSelectDropdown), {
                modelValue: _unref(axis),
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(axis) ? (axis).value = $event : null)),
                label: _unref(t)('platform.webshop.axis'),
                placeholder: _unref(t)('platform.webshop.placeHolders.axis'),
                options: _unref(axisOptions),
                "data-dusk": "axis-select"
              }, null, 8, ["modelValue", "label", "placeholder", "options"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_14, [
        (_unref(packOptions) && _unref(packOptions).length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createVNode(_unref(BaseSelectDropdown), {
                modelValue: _unref(pack),
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(pack) ? (pack).value = $event : null)),
                label: _unref(t)('platform.webshop.pack'),
                placeholder: _unref(t)('platform.webshop.placeHolders.pack'),
                options: _unref(packOptions),
                "data-dusk": "pack-select"
              }, null, 8, ["modelValue", "label", "placeholder", "options"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createVNode(_unref(NumberInput), {
            modelValue: _unref(quantity),
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(quantity) ? (quantity).value = $event : null)),
            label: _unref(t)('platform.webshop.quantity'),
            placeholder: _unref(t)('platform.webshop.placeHolders.quantity'),
            "data-dusk": "quantity-input"
          }, null, 8, ["modelValue", "label", "placeholder"])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["flex gap-6 items-end", _unref(packOptions) && _unref(packOptions).length > 0 ? 'col-span-3' : 'col-span-4'])
        }, [
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_unref(BaseTextInput), {
              modelValue: _unref(reference),
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(reference) ? (reference).value = $event : null)),
              label: _unref(t)('platform.webshop.reference'),
              count: 30,
              "is-optional": "",
              placeholder: _unref(t)('platform.webshop.placeHolders.reference'),
              "data-dusk": "reference-input",
              onInput: _unref(validateReference)
            }, {
              suffix: _withCtx(() => [
                _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(reference) ? _unref(reference).length : 0) + "/30", 1)
              ]),
              _: 1
            }, 8, ["modelValue", "label", "placeholder", "onInput"])
          ])
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_unref(SearchInput), {
              modelValue: _unref(patientSearchText),
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(patientSearchText) ? (patientSearchText).value = $event : null)),
              icon: _unref(patient) !== null ? 'check-square' : 'search',
              label: _unref(t)('platform.webshop.patient'),
              placeholder: _unref(t)('platform.webshop.placeHolders.search-patient'),
              suggestions: _unref(patientSuggestions),
              loading: _unref(isPatientSearchLoading),
              clear: true,
              "is-optional": true,
              "add-button-link-label": _unref(t)('platform.webshop.add-patient'),
              "add-button-link": "add-patient",
              "add-button-as-event": true,
              "data-dusk": "patient-search-input",
              onChange: _unref(handlePatientChange),
              onAddButtonClick: _cache[9] || (_cache[9] = ($event: any) => (showModal.value = true))
            }, null, 8, ["modelValue", "icon", "label", "placeholder", "suggestions", "loading", "add-button-link-label", "onChange"])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_unref(BaseButton), {
              size: "large",
              "left-icon": 'add',
              class: "px-6 py-3 bg-blue-600 rounded-md hover:bg-blue-700 flex items-center gap-2 w-full",
              disabled: _unref(isAddToCartDisabled) || _unref(isPatientSetting),
              loading: _unref(isPatientSetting),
              "data-dusk": "add-to-cart-button",
              onClick: _unref(handleAddToCart)
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('platform.webshop.addToCart')), 1)
              ]),
              _: 1
            }, 8, ["disabled", "loading", "onClick"])
          ])
        ])
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (showModal.value)
        ? (_openBlock(), _createBlock(AddPatientModal, {
            key: 0,
            "organisation-id": currentOrganisationId.value,
            onClose: _cache[10] || (_cache[10] = ($event: any) => (showModal.value = false)),
            onSuccess: handlePatientCreated
          }, null, 8, ["organisation-id"]))
        : _createCommentVNode("", true)
    ]))
  ], 8, _hoisted_1))
}
}

})